import Anchor from 'components/typography/anchor';

const getBackgroundColorClass = ({
  signCount,
  maxCount,
}: {
  signCount: number;
  maxCount: number;
}): string => {
  const normalizedValue = signCount / maxCount;

  if (normalizedValue === 0) {
    // inactive
    return 'bg-stone text-stone-400 dark:bg-stone-700 dark:text-stone-300 aspect-square';
  }

  if (normalizedValue > 0 && normalizedValue < 0.05) {
    // cold
    return 'bg-sky-200 text-black aspect-square max-[320px]:text-transparent';
  }

  if (normalizedValue >= 0.05 && normalizedValue < 0.15) {
    // medium
    return 'bg-sky-400 text-black aspect-square max-[320px]:text-transparent';
  }

  if (normalizedValue >= 0.15 && normalizedValue < 0.25) {
    // hot
    return 'bg-sky-600 text-black aspect-square max-[320px]:text-transparent';
  }

  if (normalizedValue >= 0.25) {
    // veryHot
    return 'bg-sky-800 text-white aspect-square max-[320px]:text-transparent';
  }

  // If something falls through above, at least default to something.
  return 'bg-sky-50 text-black aspect-square max-[320px]:text-transparent';
};

const stateGrid = [
  {
    state: 'AK',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/AK`}
        key={'AK'}
        data-test-id={'AK'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        AK
      </Anchor>
    ),
  },
  {
    state: 'ME',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/ME`}
        key={'ME'}
        data-test-id={'ME'}
        className={`col-start-12 ${backgroundColorClass}`}
        prefetch={false}
      >
        ME
      </Anchor>
    ),
  },
  {
    state: 'VT',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/VT`}
        key={'VT'}
        data-test-id={'VT'}
        className={`col-start-10 ${backgroundColorClass}`}
        prefetch={false}
      >
        VT
      </Anchor>
    ),
  },
  {
    state: 'NH',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/NH`}
        key={'NH'}
        data-test-id={'NH'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        NH
      </Anchor>
    ),
  },
  {
    state: 'MA',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/MA`}
        key={'MA'}
        data-test-id={'MA'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        MA
      </Anchor>
    ),
  },
  {
    state: 'WA',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/WA`}
        key={'WA'}
        data-test-id={'WA'}
        className={`col-start-2 ${backgroundColorClass}`}
        prefetch={false}
      >
        WA
      </Anchor>
    ),
  },
  {
    state: 'MT',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/MT`}
        key={'MT'}
        data-test-id={'MT'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        MT
      </Anchor>
    ),
  },
  {
    state: 'ND',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/ND`}
        key={'ND'}
        data-test-id={'ND'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        ND
      </Anchor>
    ),
  },
  {
    state: 'SD',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/SD`}
        key={'SD'}
        data-test-id={'SD'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        SD
      </Anchor>
    ),
  },
  {
    state: 'MN',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/MN`}
        key={'MN'}
        data-test-id={'MN'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        MN
      </Anchor>
    ),
  },
  {
    state: 'WI',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/WI`}
        key={'WI'}
        data-test-id={'WI'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        WI
      </Anchor>
    ),
  },
  {
    state: 'MI',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/MI`}
        key={'MI'}
        data-test-id={'MI'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        MI
      </Anchor>
    ),
  },
  {
    state: 'NY',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/NY`}
        key={'NY'}
        data-test-id={'NY'}
        className={`col-start-10 ${backgroundColorClass}`}
        prefetch={false}
      >
        NY
      </Anchor>
    ),
  },
  {
    state: 'CT',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/CT`}
        key={'CT'}
        data-test-id={'CT'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        CT
      </Anchor>
    ),
  },
  {
    state: 'RI',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/RI`}
        key={'RI'}
        data-test-id={'RI'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        RI
      </Anchor>
    ),
  },
  {
    state: 'OR',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/OR`}
        key={'OR'}
        data-test-id={'OR'}
        className={`col-start-2 ${backgroundColorClass}`}
        prefetch={false}
      >
        OR
      </Anchor>
    ),
  },
  {
    state: 'ID',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/ID`}
        key={'ID'}
        data-test-id={'ID'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        ID
      </Anchor>
    ),
  },
  {
    state: 'WY',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/WY`}
        key={'WY'}
        data-test-id={'WY'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        WY
      </Anchor>
    ),
  },
  {
    state: 'NE',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/NE`}
        key={'NE'}
        data-test-id={'NE'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        NE
      </Anchor>
    ),
  },
  {
    state: 'IA',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/IA`}
        key={'IA'}
        data-test-id={'IA'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        IA
      </Anchor>
    ),
  },
  {
    state: 'IL',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/IL`}
        key={'IL'}
        data-test-id={'IL'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        IL
      </Anchor>
    ),
  },
  {
    state: 'IN',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/IN`}
        key={'IN'}
        data-test-id={'IN'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        IN
      </Anchor>
    ),
  },
  {
    state: 'OH',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/OH`}
        key={'OH'}
        data-test-id={'OH'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        OH
      </Anchor>
    ),
  },
  {
    state: 'PA',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/PA`}
        key={'PA'}
        data-test-id={'PA'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        PA
      </Anchor>
    ),
  },
  {
    state: 'NJ',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/NJ`}
        key={'NJ'}
        data-test-id={'NJ'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        NJ
      </Anchor>
    ),
  },
  {
    state: 'CA',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/CA`}
        key={'CA'}
        data-test-id={'CA'}
        className={`col-start-1 ${backgroundColorClass}`}
        prefetch={false}
      >
        CA
      </Anchor>
    ),
  },
  {
    state: 'NV',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/NV`}
        key={'NV'}
        data-test-id={'NV'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        NV
      </Anchor>
    ),
  },
  {
    state: 'UT',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/UT`}
        key={'UT'}
        data-test-id={'UT'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        UT
      </Anchor>
    ),
  },
  {
    state: 'CO',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/CO`}
        key={'CO'}
        data-test-id={'CO'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        CO
      </Anchor>
    ),
  },
  {
    state: 'KS',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/KS`}
        key={'KS'}
        data-test-id={'KS'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        KS
      </Anchor>
    ),
  },
  {
    state: 'MO',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/MO`}
        key={'MO'}
        data-test-id={'MO'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        MO
      </Anchor>
    ),
  },
  {
    state: 'KY',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/KY`}
        key={'KY'}
        data-test-id={'KY'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        KY
      </Anchor>
    ),
  },
  {
    state: 'WV',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/WV`}
        key={'WV'}
        data-test-id={'WV'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        WV
      </Anchor>
    ),
  },
  {
    state: 'DC',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/DC`}
        key={'DC'}
        data-test-id={'DC'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        DC
      </Anchor>
    ),
  },
  {
    state: 'MD',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/MD`}
        key={'MD'}
        data-test-id={'MD'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        MD
      </Anchor>
    ),
  },
  {
    state: 'DE',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/DE`}
        key={'DE'}
        data-test-id={'DE'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        DE
      </Anchor>
    ),
  },
  {
    state: 'AZ',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/AZ`}
        key={'AZ'}
        data-test-id={'AZ'}
        className={`col-start-3 ${backgroundColorClass}`}
        prefetch={false}
      >
        AZ
      </Anchor>
    ),
  },
  {
    state: 'NM',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/NM`}
        key={'NM'}
        data-test-id={'NM'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        NM
      </Anchor>
    ),
  },
  {
    state: 'OK',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/OK`}
        key={'OK'}
        data-test-id={'OK'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        OK
      </Anchor>
    ),
  },
  {
    state: 'AR',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/AR`}
        key={'AR'}
        data-test-id={'AR'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        AR
      </Anchor>
    ),
  },
  {
    state: 'TN',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/TN`}
        key={'TN'}
        data-test-id={'TN'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        TN
      </Anchor>
    ),
  },
  {
    state: 'VA',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/VA`}
        key={'VA'}
        data-test-id={'VA'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        VA
      </Anchor>
    ),
  },
  {
    state: 'NC',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/NC`}
        key={'NC'}
        data-test-id={'NC'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        NC
      </Anchor>
    ),
  },
  {
    state: 'TX',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/TX`}
        key={'TX'}
        data-test-id={'TX'}
        className={`col-start-4 ${backgroundColorClass}`}
        prefetch={false}
      >
        TX
      </Anchor>
    ),
  },
  {
    state: 'LA',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/LA`}
        key={'LA'}
        data-test-id={'LA'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        LA
      </Anchor>
    ),
  },
  {
    state: 'MS',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/MS`}
        key={'MS'}
        data-test-id={'MS'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        MS
      </Anchor>
    ),
  },
  {
    state: 'AL',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/AL`}
        key={'AL'}
        data-test-id={'AL'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        AL
      </Anchor>
    ),
  },
  {
    state: 'GA',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/GA`}
        key={'GA'}
        data-test-id={'GA'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        GA
      </Anchor>
    ),
  },
  {
    state: 'SC',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/SC`}
        key={'SC'}
        data-test-id={'SC'}
        className={`${backgroundColorClass}`}
        prefetch={false}
      >
        SC
      </Anchor>
    ),
  },
  {
    state: 'HI',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/HI`}
        key={'HI'}
        data-test-id={'HI'}
        className={`col-start-1 ${backgroundColorClass}`}
        prefetch={false}
      >
        HI
      </Anchor>
    ),
  },
  {
    state: 'FL',
    component: ({
      backgroundColorClass,
      basePath,
    }: {
      backgroundColorClass: string;
      basePath: string;
    }) => (
      <Anchor
        href={`${basePath}/explore/FL`}
        key={'FL'}
        data-test-id={'FL'}
        className={`col-start-8 ${backgroundColorClass}`}
        prefetch={false}
      >
        FL
      </Anchor>
    ),
  },
];

export { getBackgroundColorClass, stateGrid };
